import { Rectangle } from './Rectangle';

export class Tree {

    _area;
    _depth;
    _data = null;
    _point: { x: number; y: number; } | null = null;
    children: Tree[] = [];
    _distance = NaN;
    
    constructor(area:Rectangle, depth:number) {
        this._area = area;
        this._depth = depth;
    }

    attachToChild(newPoint:{y:number, x:number}, newData:number) {
        const index = this.getChildWhichContentPoint(newPoint);

        if(typeof this.children[ index ] === 'undefined' || this.children[ index ] === null) {
            const width = this._area.width / 2;
            const height = this._area.height / 2;
            const startX = !( index % 2 ) ? this._area.x + width :this._area.x;
            const startY = index > 2 ? this._area.y + height :this._area.y;
            this.children[ index ] = new Tree(
                new Rectangle( startX, startY, width, height ),
                this._depth + 1
            );
        }
        this.children[index].push(newPoint, newData);
    }

    push(point: any, data: any){
        let newPoint = point;
        let newData = data;

        const distance = this.getDistance();
        const distanceFromNewPoint = this.getDistanceFromPoint(point);
        if(distance > distanceFromNewPoint) {
            newPoint = this._point;
            this._point = point;

            newData = this._data;
            this._data = data;

            this._distance = NaN;
        }
        if(newPoint != null)
            this.attachToChild(newPoint, newData);
    }
    
    pull (rectangle: Rectangle, maxDepth: number, array:any[]) {
        if(!this.interact(this._area, rectangle))
            return;

        if(this._data != null && this._point &&  rectangle.contains(this._point)) array.push( this._data );

        if(maxDepth == this._depth) return;
        
        for(let i=1; i<5; i++){
            if(typeof this.children[ i ] !== 'undefined' && this.children[ i ] !== null)
                this.children[ i ].pull(rectangle, maxDepth, array);
            
        }
            
    }
    interact = function(firstRectangle:Rectangle, secondRectangle:Rectangle)
    {
        if( firstRectangle.x > secondRectangle.x + secondRectangle.width || firstRectangle.x + firstRectangle.width < secondRectangle.x ) return false;
        
        if( firstRectangle.y > secondRectangle.y + secondRectangle.height || firstRectangle.y + firstRectangle.height < secondRectangle.y )  return false;

        return true;
    }
    
    getChildWhichContentPoint(point:{y:number, x:number}) {
        var middle = this._area.getMiddle();
        var center = this._area.getCenter();
        var index = 1;
        if(point.y >= middle)
            index = 3;
        if(point.x >= center)
            index ++;
        return index;
    }

    getDistance() {
        if(isNaN(this._distance)) {
            if(this._point == null)
                return Number.MAX_VALUE;
            this._distance = this.getDistanceFromPoint(this._point);
        }
        return this._distance;
    }
    getDistanceFromPoint(point:{y:number, x:number}){
        const x = this._area.x - point.x;
        const y = this._area.y - point.y;
        return  Math.sqrt( x*x + y*y );
    }

    getArea () {
        return this._area;
    };
    
    
}
